import { render, staticRenderFns } from "./AdoptionReportSchoolTotal.vue?vue&type=template&id=20db27f4&"
import script from "./AdoptionReportSchoolTotal.vue?vue&type=script&lang=js&"
export * from "./AdoptionReportSchoolTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports